import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React from 'react';
import CommonHeader from './CommonHeader.js';
import { HeaderNPayMonoButton } from './HeaderNpayButton.js';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import '@babel/runtime-corejs3/core-js-stable/instance/fill';
import IcQMark from '../icons/IcQMark.js';
import useHeaderBrandLogo from '../../hooks/useHeaderBrandLogo.js';
import styles from './HeaderBrandWindow.module.scss.js';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
/**
 * 서비스별 2-depth 헤더
 */
function HeaderBrandWindow(_ref) {
  var title = _ref.title,
    rightComponent = _ref.rightComponent,
    children = _ref.children,
    _ref$hasTooltip = _ref.hasTooltip,
    hasTooltip = _ref$hasTooltip === void 0 ? false : _ref$hasTooltip,
    isPayApp = _ref.isPayApp,
    onClickTooltip = _ref.onClickTooltip,
    _ref$brandLogo = _ref.brandLogo,
    brandLogo = _ref$brandLogo === void 0 ? {} : _ref$brandLogo;
  var _useHeaderBrandLogo = useHeaderBrandLogo(brandLogo),
    npayLogo = _useHeaderBrandLogo.npayLogo;
  return /*#__PURE__*/React.createElement(CommonHeader, {
    align: "center",
    rightComponent: rightComponent,
    innerClassName: cx('article')
  }, /*#__PURE__*/React.createElement("h1", {
    className: cx('npay-wrapper')
  }, /*#__PURE__*/React.createElement(HeaderNPayMonoButton, _objectSpread({
    isPayApp: isPayApp
  }, npayLogo))), /*#__PURE__*/React.createElement("h2", {
    className: cx('title', {
      'has-tooltip': hasTooltip
    })
  }, title, hasTooltip && ( /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('button-tooltip'),
    onClick: onClickTooltip
  }, /*#__PURE__*/React.createElement(IcQMark, {
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uD234\uD301 \uBCF4\uAE30")))), children);
}

export { HeaderBrandWindow as default };
